import { render, staticRenderFns } from "./DroopyClinicServices.vue?vue&type=template&id=77bb8cf7&scoped=true&"
import script from "./DroopyClinicServices.vue?vue&type=script&lang=js&"
export * from "./DroopyClinicServices.vue?vue&type=script&lang=js&"
import style0 from "./DroopyClinicServices.vue?vue&type=style&index=0&id=77bb8cf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bb8cf7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VChip,VDataTable,VDialog,VIcon,VRow,VSnackbar,VTooltip})
